import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Skeleton } from '@mui/material';

interface OutlinedCardProps {
  nome: string;
  valor: number;
  cor: string;
  loading: boolean;
}

const OutlinedCard: React.FC<OutlinedCardProps> = ({ nome, valor, cor, loading }) => {
  return (
    <Box sx={{ margin: 0.1 }} >
      <Card variant="outlined" sx={{ borderRadius: '8px' }}>
        <CardContent style={{ border: '1px solid #ccc', borderRadius: '8px', padding: '8px', display: 'flex' }}>
          {/* <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box style={{ border: '1px solid #ccc', borderRadius: '8px', padding: '3px', backgroundColor: cor }} sx={{ width: '0.1px', height: '60px' }} />
          </Box> */}
          <Box sx={{ flex: '1 0 auto', margin: 0.1 }}>
            <Typography sx={{ fontSize: 18 }} >
              {nome}
            </Typography>
            <Typography sx={{ fontSize: 20 }} color="text.secondary">
              {loading ? <Skeleton variant="text" /> : valor}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
 
export default OutlinedCard; 
